import React, { memo } from 'react';
import styled from 'styled-components';

const Refunded = styled.div`
  border-radius: 3px;
  border: 1px solid ${(props) => props.theme.colors.notificationWarning};
  background-color: ${(props) => props.theme.colors.notificationWarning};
  color: white;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  line-height: 99%;
  margin: 0;
  padding: 2px 5px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const AmazonRefundFormatter = ({ value }: { value: boolean }) => {
  switch (value) {
    case true:
      return <Refunded>REFUNDED</Refunded>;
    default:
      return <span />;
  }
};

export default memo(AmazonRefundFormatter, (prevProps, nextProps) => prevProps.value === nextProps.value);
